export default __webpack_public_path__ + "static/2020_clean_water_act_violations_districts-35054ae1394282f7277993cc474a75f7.webp";